// GunPartsCentral Shopify Theme JS
// Mobile-first, real products from Shopify collections (Spark + supplier sync)
// Lean JS for performance and AI search optimization.

(function syncHeaderOffset() {
  var last = -1;
  var mosaicChrome = 0;
  function run() {
    var header = document.getElementById('shopify-section-header');
    var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
    if (h !== last) {
      last = h;
      document.documentElement.style.setProperty('--gpc-header-h', h + 'px');
    }
    if (h > mosaicChrome && !document.documentElement.classList.contains('gpc-ticker-away')) {
      mosaicChrome = h;
      document.documentElement.style.setProperty('--gpc-mosaic-chrome', h + 'px');
    }
  }
  window.gpcSyncHeaderOffset = run;
  run();
  window.addEventListener('resize', run);
  window.addEventListener('orientationchange', function () {
    mosaicChrome = 0;
    last = -1;
    setTimeout(run, 280);
  });
  document.addEventListener('DOMContentLoaded', run);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  var header = document.getElementById('shopify-section-header');
  if (header && window.ResizeObserver) new ResizeObserver(run).observe(header);
})();



// === MOBILE FOCUS STABILIZER ===
// On mobile (esp. iOS Safari), focusing the search input often triggers an aggressive
// auto-scroll that "jumps the bar to the top of the screen" and shifts the content below
// (logo + featured products on index, or results on /search). scroll-margin helps a little
// but is not enough alone because of sticky header + keyboard viewport resize timing.
// This captures the scroll position on focus and restores it shortly after (after the
// keyboard animation settles). Safe on desktop (early return). Attached to every search input.
var attachMobileSearchFocusStabilizer = window.attachMobileSearchFocusStabilizer = function attachMobileSearchFocusStabilizer(inputEl, containerEl) {
  if (!inputEl) return;

  // Capture the scroll position *before* the browser processes the tap-to-focus.
  // This is more reliable than only in the focus handler (the OS may scroll during focus).
  const saveScroll = function () {
    if (window.innerWidth >= 768) return;
    inputEl._gpcSavedY = window.scrollY;
  };
  inputEl.addEventListener('touchstart', saveScroll, { passive: true });
  inputEl.addEventListener('mousedown', saveScroll);

  // Also listen on the container/form area in case the tap lands on the icon or edge.
  if (containerEl) {
    containerEl.addEventListener('touchstart', saveScroll, { passive: true });
  }

  inputEl.addEventListener('focus', function () {
    if (window.innerWidth >= 768) return; // desktop is fine; only tame mobile
    // Bottom "Search parts" button: we *want* to jump to the header bar.
    if (window._gpcJumpToSearch || inputEl._gpcAllowScrollToSearch) return;
    const startY = (inputEl._gpcSavedY != null) ? inputEl._gpcSavedY : window.scrollY;

    const restore = () => {
      if (window._gpcSnapToResults || window._gpcJumpToSearch) return;
      const cur = window.scrollY;
      // Only snap back if the browser jumped us by a noticeable amount.
      // This keeps the search bar stable in the sticky header and the content below
      // (featured products etc.) from leaping up or disappearing when the keyboard opens.
      // Also try to keep the full header (logo + branding) and products in view.
      if (Math.abs(cur - startY) > 10) {
        window.scrollTo({ top: startY, behavior: 'instant' });
      }
    };

    // Immediate lock to fight the browser's instant auto-scroll on focus.
    restore();

    // Keyboard slide-up + visualViewport resize timing varies a lot on real devices and sims.
    // Frequent attempts (including rAF style) to catch and hold the position so the bar
    // and site (branding, items) do not move or disappear. Only the results dropdown changes.
    setTimeout(restore, 0);
    setTimeout(restore, 50);
    setTimeout(restore, 120);
    setTimeout(restore, 220);
    setTimeout(restore, 320);
    setTimeout(restore, 450);
    setTimeout(restore, 600);

    // Also use a short burst of rAF for very early reflows.
    let rafCount = 0;
    const rafRestore = () => {
      restore();
      if (rafCount++ < 6) requestAnimationFrame(rafRestore);
    };
    requestAnimationFrame(rafRestore);

    // Clean the saved value after a bit.
    setTimeout(() => { inputEl._gpcSavedY = null; }, 1200);
  });
};

window.attachSearchClear = function attachSearchClear(formEl, inputEl, onCleared) {
  if (!formEl || !inputEl || formEl.querySelector('.gpc-search-clear')) return;
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'gpc-search-clear';
  btn.setAttribute('aria-label', 'Clear search');
  btn.hidden = true;
  btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="16" height="16" aria-hidden="true"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM6.72 6.72a.75.75 0 011.06 0L10 8.94l2.22-2.22a.75.75 0 111.06 1.06L11.06 10l2.22 2.22a.75.75 0 11-1.06 1.06L10 11.06l-2.22 2.22a.75.75 0 01-1.06-1.06L8.94 10 6.72 7.78a.75.75 0 010-1.06z" clip-rule="evenodd"/></svg>';
  formEl.appendChild(btn);
  function sync() {
    var has = !!(inputEl.value && String(inputEl.value).length);
    btn.hidden = !has;
    formEl.classList.toggle('gpc-search-has-value', has);
  }
  function clear() {
    inputEl.value = '';
    sync();
    if (typeof onCleared === 'function') onCleared();
    else inputEl.dispatchEvent(new Event('input', { bubbles: true }));
    try { inputEl.focus(); } catch (e) {}
  }
  btn.addEventListener('mousedown', function (e) { e.preventDefault(); });
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    clear();
  });
  inputEl.addEventListener('input', sync);
  inputEl.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && inputEl.value) {
      e.preventDefault();
      clear();
    }
  });
  sync();
};

// iOS will not paint :active unless some touch listener exists. Pointer class
// also keeps the yellow type-card outline up for the length of the press.
(function gpcTypeHitPress() {
  var sel = '.gpc-type-hit, .gpc-browse-card, #gpc-firearm-browse nav a';
  function press(e) {
    var el = e.target && e.target.closest && e.target.closest(sel);
    if (!el) return;
    el.classList.add('is-pressed');
  }
  function clear() {
    document.querySelectorAll('.is-pressed').forEach(function (n) {
      n.classList.remove('is-pressed');
    });
  }
  document.addEventListener('touchstart', function () {}, { passive: true });
  document.addEventListener('pointerdown', press, { passive: true });
  document.addEventListener('pointerup', clear, { passive: true });
  document.addEventListener('pointercancel', clear, { passive: true });
  document.addEventListener('pointerleave', function (e) {
    if (e.target && e.target.classList) e.target.classList.remove('is-pressed');
  }, true);
})();

window.gpcMobileBack = function gpcMobileBack() {
  try {
    if (document.referrer) {
      var from = new URL(document.referrer);
      if (from.origin === window.location.origin) {
        window.history.back();
        return;
      }
    }
  } catch (e) {}
  window.location.href = '/';
};

// Mobile bottom bar: scroll the sticky header search into view, then focus it.
window.gpcSnapToSearchResults = function gpcSnapToSearchResults() {
  window._gpcSnapToResults = true;
  var page = document.getElementById('algolia-search-page') || document.getElementById('algolia-hits');
  function go() {
    if (!page) {
      window.scrollTo(0, 0);
      return;
    }
    var header = document.getElementById('shopify-section-header');
    var hh = header ? header.getBoundingClientRect().height : 0;
    var y = page.getBoundingClientRect().top + window.scrollY - hh;
    if (y < 0) y = 0;
    window.scrollTo(0, y);
  }
  go();
  setTimeout(go, 50);
  setTimeout(go, 160);
  setTimeout(go, 320);
  setTimeout(function () { window._gpcSnapToResults = false; }, 900);
};

window.gpcFocusHeaderSearch = function gpcFocusHeaderSearch() {
  var input = document.getElementById('search-input');
  var header = document.querySelector('.gpc-sticky-header');
  window._gpcJumpToSearch = true;
  if (input) input._gpcAllowScrollToSearch = true;
  if (header && header.scrollIntoView) {
    header.scrollIntoView({ block: 'start', behavior: 'auto' });
  } else {
    window.scrollTo(0, 0);
  }
  function focusInput() {
    if (!input) return;
    try { input.focus(); } catch (e) {}
  }
  focusInput();
  setTimeout(focusInput, 50);
  setTimeout(focusInput, 200);
  setTimeout(function () {
    window._gpcJumpToSearch = false;
    if (input) input._gpcAllowScrollToSearch = false;
  }, 800);
};

// === EARLY ROBUST SEARCH BAR INITIALIZATION ===
// We run this right after the ultra-early gate hide so the Algolia (or fallback) search input
// is guaranteed to appear in the #algolia-autocomplete container in the header.
// This addresses "search bar is not available".
// Full Algolia autocomplete only mounts if the CDN libs + container are ready.
// Otherwise we inject a visible styled <input> so the UI is always present for testing.
(function initSearchBarEarly() {
  const container = document.getElementById('algolia-autocomplete');
  if (!container) {
    console.warn('[Search] #algolia-autocomplete container missing in DOM at early init');
    return;
  }

  // Try full Algolia path first (the reason we have the CDNs in theme.liquid)
  const algolia = window.algoliasearch;
  const canUseAlgolia = typeof algolia === 'function';

  // Read Algolia credentials from theme settings (set in the theme editor under "Algolia Search").
  // Falls back to your known good values (from earlier) so the full search works immediately
  // while you locate the settings panel in the editor.
  const algoliaConfig = (window.GPC && window.GPC.algolia) || {};
  const APP_ID = (algoliaConfig.appId || 'ZKZZ0JXNAD').trim();
  const SEARCH_KEY = (algoliaConfig.searchKey || '23c63e7556f84a79f2ad20bd9f439233').trim();
  const INDEX = (algoliaConfig.index || 'shopify_products').trim();

  const usingPlaceholders = !APP_ID || !SEARCH_KEY || APP_ID.includes('YOUR_') || SEARCH_KEY.includes('YOUR_') || INDEX.includes('YOUR_');

  if (canUseAlgolia && !usingPlaceholders) {
    try {
      const client = algolia(APP_ID, SEARCH_KEY);
      const onSearchResultsPage = !!document.getElementById('algolia-hits') || window.location.pathname === '/search';
      if (onSearchResultsPage) {
        // On the search results page, we deliberately do *not* mount the full Algolia Autocomplete.
        // The search.liquid script will inject a simple plain <input> into #algolia-autocomplete
        // and wire it live to the page's InstantSearch instance (see below).
        // This keeps the current results visible and prevents the header search bar from
        // causing the results to disappear or the UI to jump around (especially bad on mobile).
        return;
      }

      // For the index (and other non-search pages): use the EXACT same manual .aa-Form + absolute gray icon + input
      // as on the search results page. This guarantees identical DOM structure, focus/scroll behavior,
      // stabilizer effectiveness, and no library side-effects. The bar stays put on mobile focus,
      // branding and products below remain visible, only the dropdown changes when typing.
      // We still use the Algolia client for live fetching to power a matching custom dropdown.
      container.innerHTML = `
        <form class="aa-Form" id="gpc-search-form" action="/search" method="get" role="search">
          <div class="gpc-search-icon text-zinc-400 pointer-events-none" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.25" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          <input
            id="search-input"
            name="q"
            type="search"
            enterkeyhint="search"
            class="aa-Input search-input w-full text-white placeholder-zinc-500 rounded-3xl pl-7 pr-3 py-2 text-sm md:text-[15px] focus:outline-none scroll-mt-20"
            placeholder="Glock 19 10-rd mag, AR-15 stock, RMR 2 MOA red dot"
            autocomplete="off"
            autocapitalize="off"
            spellcheck="false"
          />
        </form>
        <div id="gpc-search-dropdown" class="aa-Panel gpc-autocomplete-panel" style="display:none; position:absolute; top:100%; left:0; right:0; margin-top:4px; z-index:70;"></div>
      `;
      container.style.position = 'relative'; // so the absolute dropdown positions correctly below the bar

      const formEl = container.querySelector('#gpc-search-form');
      const inputEl = container.querySelector('#search-input');
      const dropdown = container.querySelector('#gpc-search-dropdown');

      if (inputEl) {
        attachMobileSearchFocusStabilizer(inputEl, container);
        if (formEl) window.attachSearchClear(formEl, inputEl);

        let debounceTimer = null;
        const skuCountEl = document.getElementById('full-catalog-sku-count');
        let totalSkus = null;

        // On the Full Catalog page, fetch the total SKU count once on load
        if (skuCountEl) {
          client
            .initIndex(INDEX)
            .search('', {
              hitsPerPage: 0,
            })
            .then(({ nbHits }) => {
              totalSkus = nbHits;
              skuCountEl.textContent = `${nbHits.toLocaleString('en-US')} SKUs. Sold-out items stay listed so you can request a restock alert.`;
            });
        }

        inputEl.addEventListener('input', () => {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => {
            const q = (inputEl.value || '').trim();
            if (!q) {
              dropdown.style.display = 'none';
              dropdown.innerHTML = '';
              if (skuCountEl && totalSkus !== null) {
                skuCountEl.textContent = `${totalSkus.toLocaleString('en-US')} SKUs. Sold-out items stay listed so you can request a restock alert.`;
              }
              return;
            }
            client
              .initIndex(INDEX)
              .search(q, {
                hitsPerPage: 6,
                attributesToRetrieve: ['title', 'handle', 'image', 'featured_image', 'image_url', 'thumbnail', 'price', 'price_min', 'vendor', 'brand', 'inventory_available', 'product_type', 'body_html_safe'],
                // Keep sold-out SKUs visible; boost in-stock hits so the dropdown stays useful.
                optionalFilters: ['inventory_available:true'],
              })
              .then(({ hits, nbHits }) => {
                var C = window.GPC && window.GPC.classify;
                if (C && C.restrictedOf) {
                  hits = (hits || []).filter(function (h) {
                    return !C.restrictedOf(h.title, h.vendor, h.body_html_safe, { product_type: h.product_type });
                  });
                }
                if (!hits || hits.length === 0) {
                  dropdown.style.display = 'none';
                  return;
                }
                let html = '<ul class="aa-List" style="padding:4px 0; max-height:42vh; overflow:auto;">';
                const maxDropdownItems = window.innerWidth < 640 ? 3 : 4;  // 3 items on mobile so the "View all" row is visible above the on-screen keyboard
                const displayedHits = hits.slice(0, maxDropdownItems);

                if (skuCountEl) {
                  skuCountEl.textContent = `${nbHits.toLocaleString('en-US')} SKUs meeting search criteria`;
                }
                displayedHits.forEach((item) => {
                  const itemUrl = `/products/${item.handle}?gpc_plat=search&gpc_platn=Search&gpc_search=${encodeURIComponent(q)}`;
                  const imgSrcRaw = item.image || item.featured_image || item.image_url || item.thumbnail || '';
                  const imgSrc = (window.GPC && window.GPC.img) ? window.GPC.img(imgSrcRaw, 80) : imgSrcRaw;
                  const vendor = item.vendor || item.brand || '';
                  const oos = item.inventory_available === false;
                  let price = '';
                  const raw = item.price ?? item.price_min ?? '';
                  if (raw !== '') {
                    let p = typeof raw === 'string' ? parseFloat(raw) : raw;
                    if (!isNaN(p)) {
                      price = '$' + p.toFixed(2);
                    }
                  }
                  const picture = imgSrc
                    ? `<img src="${imgSrc}" alt="${(window.GPC && window.GPC.esc) ? window.GPC.esc(item.title || 'Product') : (item.title || 'Product')}" style="width:100%; height:100%; object-fit:cover; border-radius:4px; border:1px solid #3f3f46; display:block; background:#27272a;" />`
                    : `<div style="width:100%; height:100%; background:#27272a; border-radius:4px; border:1px solid #3f3f46;"></div>`;
                  html += `
                    <li class="aa-Item" style="min-height:48px;">
                      <a href="${itemUrl}" style="display:flex; align-items:center; padding:8px 12px; text-decoration:none; color:#f3f4f6;">
                        <div style="width:32px; height:32px; min-width:32px; flex-shrink:0; overflow:hidden; border-radius:4px; margin-right:8px; border:1px solid #3f3f46;">
                          ${picture}
                        </div>
                        <div style="flex:1; min-width:0; overflow:hidden;">
                          <div style="font-weight:500; font-size:14px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${(window.GPC && window.GPC.esc) ? window.GPC.esc(item.title || '') : (item.title || '')}</div>
                          ${(vendor || price || oos) ? `<div style="font-size:11px; color:#a1a1aa; display:flex; gap:6px; margin-top:2px; flex-wrap:wrap;">${vendor ? `<span>${vendor}</span>` : ''}${price ? `<span>${price}</span>` : ''}${oos ? `<span style="color:#f87171;">Out of stock</span>` : ''}</div>` : ''}
                        </div>
                      </a>
                    </li>
                  `;
                });
                // Always show the "See all results" row at the bottom whenever we have any items in the dropdown.
                // This matches the original aa.autocomplete dropdown behavior (the link was added whenever results.length > 0).
                // It ensures the final option is always present on real mobile devices (not just sim/desktop) and for small result sets.
                if (displayedHits.length > 0) {
                  const seeAllUrl = `/search?q=${encodeURIComponent(q)}`;
                  html += `
                    <li class="aa-Item" style="min-height:68px; border-top:1px solid #3f3f46; display:flex; align-items:center; background:rgba(250,250,250,0.08);">
                      <a href="${seeAllUrl}" style="display:block; width:100%; padding:16px 20px; text-align:center; color:#fafafa; font-size:16px; font-weight:700; text-decoration:none; line-height:1.2;">
                        View all ${Number(nbHits).toLocaleString('en-US')} results for “${q}” →
                      </a>
                    </li>
                  `;
                }
                html += '</ul>';
                dropdown.innerHTML = html;
                dropdown.style.display = 'block';

                // Close on item clicks (href navigation will proceed)
                dropdown.querySelectorAll('a').forEach((a) => {
                  a.addEventListener('click', () => {
                    dropdown.style.display = 'none';
                  });
                });
              })
              .catch((err) => {
                console.warn('[Search] dropdown fetch error:', err);
                dropdown.style.display = 'none';
              });
          }, 220);
        });

        // Close dropdown on blur / outside click / Escape (standard UX, keeps bar stable)
        const closeDropdown = () => {
          dropdown.style.display = 'none';
        };
        inputEl.addEventListener('blur', () => setTimeout(closeDropdown, 180));
        document.addEventListener('click', (e) => {
          if (!container.contains(e.target)) closeDropdown();
        });
        inputEl.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') closeDropdown();
        });

        // Enter (desktop) and the mobile keyboard search/checkmark both submit this form.
        // Same destination as the yellow "View all N results" row — nothing else in the bar changes.
        const goToAllResults = () => {
          const q = (inputEl.value || '').trim();
          if (!q) return;
          window._gpcSnapToResults = true;
          window.location.href = `/search?q=${encodeURIComponent(q)}`;
        };
        if (formEl) {
          formEl.addEventListener('submit', (e) => {
            e.preventDefault();
            goToAllResults();
          });
        }

      }
      return; // success, no aa.autocomplete mount (avoids library focus/scroll/panel interference on mobile)
    } catch (e) {
      console.warn('[Search] Algolia mount failed, falling back to plain input:', e);
    }
  } else if (usingPlaceholders) {
    console.warn('[Search] Algolia config missing or still contains placeholders. Using fallback input.');
  }

  // Fallback: create a visible, styled search input so the bar is "available" for testing the layout / flow.
  // This matches the icon positioning (pl-9) and the .search-input CSS.
  container.innerHTML = `
    <input 
      id="search-input"
      type="text"
      class="search-input w-full bg-zinc-900 border border-zinc-700 focus:border-yellow-400 focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:ring-offset-zinc-950 text-white placeholder-zinc-500 rounded-3xl pl-9 pr-3 py-2 text-sm md:text-[15px] focus:outline-none scroll-mt-20"
      placeholder="Glock 19 10-rd mag, AR-15 stock, RMR 2 MOA red dot"
      autocomplete="off"
    />
  `;

  const input = container.querySelector('#search-input');
  if (input) {
    // Force the pill look on the fallback too (dark rounded bar from the start).
    input.style.setProperty('background-color', '#18181b', 'important');
    input.style.setProperty('border', '1px solid #3f3f46', 'important');
    input.style.setProperty('border-radius', '9999px', 'important');

    // Attach stabilizer immediately so focus on index (or anywhere using fallback) never jumps the bar.
    attachMobileSearchFocusStabilizer(input, container);

    // Minimal client-side filter behavior using the existing filterRealFeaturedProducts if on homepage,
    // otherwise just log for now (real Algolia will replace this once keys/index are set).
    input.addEventListener('input', () => {
      if (typeof filterRealFeaturedProducts === 'function') {
        filterRealFeaturedProducts();
      }
    });
  }
})();

let cart = [];

function cartItemCount(cartData) {
  if (cartData && typeof cartData.item_count === 'number') return cartData.item_count;
  const items = (cartData && cartData.items) || (Array.isArray(cart) ? cart : []);
  return items.reduce((sum, i) => sum + (Number(i.quantity || i.qty) || 0), 0);
}

function updateCartCount(count) {
  if (count == null) count = cartItemCount();
  document.querySelectorAll('#cart-count').forEach(function (el) {
    el.textContent = String(count);
  });
}

function syncCartFromShopify() {
  return fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (res) { return res.json(); })
    .then(function (cartData) {
      cart = cartData.items || [];
      updateCartCount(cartData.item_count);
      return cartData;
    });
}
window.syncCartFromShopify = syncCartFromShopify;

function showCart() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  drawer.classList.remove('hidden');
  drawer.style.display = '';

  fetch('/cart.js', { credentials: 'same-origin' })
    .then(res => res.json())
    .then(cartData => {
      renderCartDrawer(cartData);
    })
    .catch(err => {
      console.error('Failed to load cart', err);
      const itemsEl = document.getElementById('cart-items');
      if (itemsEl) itemsEl.innerHTML = '<p class="text-red-400">Could not load cart. Please try again.</p>';
    });
}

function hideCart() {
  const drawer = document.getElementById('cart-drawer');
  if (drawer) {
    drawer.style.display = 'none';
    drawer.classList.add('hidden');
  }
}

function bindCartDrawerClicks() {
  const itemsEl = document.getElementById('cart-items');
  if (!itemsEl || itemsEl.dataset.cartBound === '1') return;
  itemsEl.dataset.cartBound = '1';
  itemsEl.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-cart-line]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const line = parseInt(btn.getAttribute('data-cart-line'), 10);
    const qty = parseInt(btn.getAttribute('data-cart-qty'), 10);
    if (!line) return;
    changeCartItemQuantity(line, isNaN(qty) ? 0 : qty);
  });
}

function gpcGoodsCents(cartData) {
  var items = (cartData && cartData.items) || [];
  var sum = Number(cartData && cartData.total_price) || 0;
  items.forEach(function (it) {
    var blob = String((it.handle || '') + ' ' + (it.url || '') + ' ' + (it.title || '') + ' ' + (it.product_title || '')).toUpperCase();
    if (!/SHIPPING PROTECTION/.test(blob)) return;
    var line = it.final_line_price != null ? it.final_line_price : it.line_price;
    sum -= Number(line) || 0;
  });
  return Math.max(0, sum);
}

function gpcPaintFreeShip(cartData) {
  var els = document.querySelectorAll('.gpc-free-ship');
  if (!els.length) return;
  var items = (cartData && cartData.items) || [];
  var total = gpcGoodsCents(cartData);
  var need = 9900 - total;
  var html = '';
  var show = items.length > 0;
  if (show && need > 0) {
    var pct = Math.max(0, Math.min(100, Math.round((total / 9900) * 100)));
    html = 'Add $' + (need / 100).toFixed(2) + ' more to reach $99 after discounts for free shipping.' +
      '<span class="gpc-free-ship-bar" aria-hidden="true"><span style="width:' + pct + '%"></span></span>';
  } else if (show) {
    html = 'Free shipping unlocked ($99+ after discounts).';
  }
  Array.prototype.forEach.call(els, function (el) {
    el.innerHTML = html;
    if (show) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  });
}

function renderCartDrawer(cartData) {
  const itemsEl = document.getElementById('cart-items');
  const subtotalEl = document.getElementById('cart-subtotal');
  if (!itemsEl || !subtotalEl) return;

  bindCartDrawerClicks();
  cart = cartData.items || [];
  updateCartCount(cartData.item_count);
  gpcPaintFreeShip(cartData);

  if (cart.length === 0) {
    itemsEl.innerHTML = '<p class="text-zinc-400">Your cart is empty.</p>';
    subtotalEl.textContent = '$0.00';
    return;
  }

  let html = '';
  let subtotal = 0;

  cart.forEach(function (item, index) {
    const price = (item.price / 100).toFixed(2);
    const linePrice = (item.line_price / 100).toFixed(2);
    subtotal += item.line_price;
    const qty = Number(item.quantity) || 0;
    const line = index + 1;

    html += `
      <div class="flex gap-3 border-b border-zinc-700 pb-3">
        <img src="${item.image || ''}" class="w-14 h-14 object-cover rounded border border-zinc-700" alt="${(window.GPC && window.GPC.esc) ? window.GPC.esc(item.title || 'Product') : String(item.title || 'Product').replace(/"/g, '&quot;')}">
        <div class="flex-1 min-w-0">
          <div class="font-medium text-sm leading-tight">${item.title}</div>
          ${item.variant_title ? `<div class="text-xs text-zinc-400">${item.variant_title}</div>` : ''}
          ${item.sku ? `<div class="text-[10px] text-zinc-500 font-mono">SKU: ${item.sku}</div>` : ''}
          ${item.properties && (item.properties.UPC || item.properties.upc) ? `<div class="text-[10px] text-zinc-500 font-mono">UPC: ${item.properties.UPC || item.properties.upc}</div>` : ''}
          <div class="text-xs mt-1">$${price} × ${qty}</div>
          <div class="mt-2 flex items-center gap-2">
            <button type="button" data-cart-line="${line}" data-cart-qty="${Math.max(0, qty - 1)}" class="tap-target h-10 w-10 border border-zinc-600 rounded-2xl text-base active:bg-zinc-800">−</button>
            <span class="min-w-[1.5rem] text-center text-sm tabular-nums">${qty}</span>
            <button type="button" data-cart-line="${line}" data-cart-qty="${qty + 1}" class="tap-target h-10 w-10 border border-zinc-600 rounded-2xl text-base active:bg-zinc-800">+</button>
            <button type="button" data-cart-line="${line}" data-cart-qty="0" class="tap-target ml-auto h-10 px-4 text-sm font-medium text-red-300 border border-red-400/50 rounded-2xl active:bg-red-950">Remove</button>
          </div>
        </div>
        <div class="text-right text-sm font-medium">$${linePrice}</div>
      </div>
    `;
  });

  itemsEl.innerHTML = html;
  subtotalEl.textContent = '$' + (subtotal / 100).toFixed(2);
}

function changeCartItemQuantity(line, newQuantity) {
  const qty = Math.max(0, Number(newQuantity) || 0);
  fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ line: line, quantity: qty })
  })
  .then(function (res) { return res.json().then(function (data) { return { res: res, data: data }; }); })
  .then(function (out) {
    if (!out.res.ok || out.data.status) {
      throw new Error(out.data.description || out.data.message || 'Cart update failed');
    }
    renderCartDrawer(out.data);
  })
  .catch(function (err) {
    console.error('Cart update failed', err);
    alert('Could not update cart. Please refresh and try again.');
  });
}
window.changeCartItemQuantity = changeCartItemQuantity;

// Lightweight live filter for the real Featured collection on homepage (small set)
function filterRealFeaturedProducts() {
  const input = document.getElementById('search-input');
  const term = (input?.value || '').toLowerCase().trim();
  const grid = document.getElementById('product-grid');
  if (!grid) return;

  const cards = grid.querySelectorAll('.product-card');
  let visible = 0;

  cards.forEach(card => {
    const text = (card.textContent || '').toLowerCase();
    const isMatch = !term || text.includes(term);
    card.style.display = isMatch ? '' : 'none';
    if (isMatch) visible++;
  });

  const countEl = document.getElementById('results-count');
  if (countEl && term) {
    countEl.textContent = `${visible} results`;
  }

  const statusEl = document.getElementById('search-status');
  if (statusEl) {
    if (term) {
      statusEl.textContent = `Showing results for “${term}”`;
      statusEl.style.display = 'block';
    } else {
      statusEl.textContent = '';
      statusEl.style.display = 'none';
    }
  }
}

function hideAgeGate(gate) {
  if (!gate) return;
  gate.classList.add('hidden');
  gate.style.display = 'none';
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
}

function showAgeGate(gate) {
  if (!gate) return;
  document.documentElement.classList.remove('gpc-age-peek');
  document.documentElement.classList.remove('gpc-age-ok');
  gate.classList.remove('hidden');
  gate.style.display = 'flex';
  gate.style.opacity = '1';
  gate.style.visibility = 'visible';
  gate.style.pointerEvents = 'auto';
  if (!gate.getAttribute('data-opened')) gate.setAttribute('data-opened', String(Date.now()));
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
}

function isKnownCrawler() {
  var ua = navigator.userAgent || '';
  return /Googlebot|Google-InspectionTool|Storebot-Google|AdsBot-Google|Google-Extended|bingbot|BingPreview|Slurp|DuckDuckBot|Baiduspider|YandexBot|facebookexternalhit|Twitterbot|LinkedInBot|Applebot|Applebot-Extended|GPTBot|ChatGPT-User|OAI-SearchBot|ClaudeBot|Claude-SearchBot|Claude-User|anthropic|PerplexityBot|Perplexity-User|Bytespider|CCBot|Amazonbot|meta-externalagent|Grok|xAI/i.test(ua);
}

function mountAgeGate() {
  if (document.getElementById('age-gate')) return null;
  var logo = (window.GPC && window.GPC.logoUrl) || '';
  var gate = document.createElement('div');
  gate.id = 'age-gate';
  gate.className = 'fixed inset-0 z-[999] flex items-center justify-center p-3';
  gate.setAttribute('role', 'dialog');
  gate.setAttribute('aria-modal', 'true');
  gate.setAttribute('aria-labelledby', 'age-gate-title');
  gate.innerHTML =
    '<div class="gpc-age-card w-full bg-zinc-900 border border-zinc-700 rounded-2xl text-center shadow-2xl">' +
      (logo ? '<img src="' + logo + '" alt="Gun Parts Central" width="32" height="32" class="gpc-age-logo gpc-logo">' : '') +
      '<p id="age-gate-title">Age verification</p>' +
      '<p class="gpc-age-copy">You must be 18 or older to view and buy parts on this site.</p>' +
      '<p class="gpc-age-q">Are you 18 or older?</p>' +
      '<div class="gpc-age-actions">' +
        '<button type="button" id="age-confirm-btn">Yes</button>' +
        '<button type="button" id="age-decline-btn">No</button>' +
      '</div>' +
      '<div class="gpc-age-signup">' +
        '<p class="gpc-age-offer">Sign up for emails from Gun Parts Central and get 10% off your first order. Terms apply.</p>' +
        '<label class="gpc-sr" for="gpc-age-email">Email</label>' +
        '<input id="gpc-age-email" type="email" autocomplete="email" inputmode="email" placeholder="Email for 10% off">' +
        '<label class="gpc-age-hp" for="gpc-age-website">Website</label>' +
        '<input id="gpc-age-website" class="gpc-age-hp" type="text" name="website" tabindex="-1" autocomplete="off">' +
        '<label class="gpc-age-consent" for="gpc-age-consent">' +
          '<input id="gpc-age-consent" type="checkbox">' +
          '<span>Email me the offer and store news.</span>' +
        '</label>' +
        '<details class="gpc-age-terms">' +
          '<summary>Terms</summary>' +
          '<p>A one-time code is emailed after you sign up. First order only. Excludes MAP brands (Magpul, Streamlight, SureFire, Leupold, Trijicon, EOTech, AGM) and other MAP items. One use. Cannot combine with other discounts.</p>' +
        '</details>' +
        '<p class="gpc-age-signup-err" id="gpc-age-signup-err" hidden></p>' +
      '</div>' +
    '</div>';
  document.body.appendChild(gate);
  return gate;
}

function initAgeGate() {
  var verified = false;
  try {
    verified = localStorage.getItem('gpc_age_verified') === 'true';
  } catch (e) {}

  if (verified || isKnownCrawler()) {
    document.documentElement.classList.remove('gpc-age-peek');
    document.documentElement.classList.add('gpc-age-ok');
    return;
  }

  var gate = document.getElementById('age-gate') || mountAgeGate();
  if (!gate) return;
  if (gate.getAttribute('data-bound') === '1') return;
  gate.setAttribute('data-bound', '1');

  var confirmBtn = document.getElementById('age-confirm-btn');
  if (confirmBtn) confirmBtn.addEventListener('click', confirmAge);
  var declineBtn = document.getElementById('age-decline-btn');
  if (declineBtn) declineBtn.addEventListener('click', declineAge);
  var emailInput = document.getElementById('gpc-age-email');
  if (emailInput) {
    emailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        confirmAge();
      }
    });
  }

  window.setTimeout(function () {
    showAgeGate(gate);
  }, 2000);
}

function ageSignupError(msg) {
  var err = document.getElementById('gpc-age-signup-err');
  if (!err) return;
  err.hidden = !msg;
  err.textContent = msg || '';
}

function submitAgeSignup() {
  var input = document.getElementById('gpc-age-email');
  var consent = document.getElementById('gpc-age-consent');
  var email = input ? String(input.value || '').trim() : '';
  if (!email) {
    ageSignupError('');
    return Promise.resolve();
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    ageSignupError('Enter a valid email, or leave it blank to enter without the offer.');
    return Promise.reject(new Error('email'));
  }
  if (!consent || !consent.checked) {
    ageSignupError('Check the box to get the offer, or clear the email to enter without it.');
    return Promise.reject(new Error('consent'));
  }
  var hp = document.getElementById('gpc-age-website');
  if (hp && String(hp.value || '').trim()) {
    return Promise.resolve();
  }
  var gate = document.getElementById('age-gate');
  var opened = gate ? parseInt(gate.getAttribute('data-opened'), 10) : 0;
  var base = (window.GPC && window.GPC.arrivalsUrl) || '';
  if (!base) {
    ageSignupError('Could not save email. Leave it blank to enter, or try again.');
    return Promise.reject(new Error('signup'));
  }
  var url = base.replace(/\/?$/, '/') + 'subscribe';
  return fetch(url, {
    method: 'POST',
    credentials: 'omit',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ email: email, consent: true, source: 'age-gate', website: hp ? hp.value : '', t: opened || Date.now() })
  }).then(function (res) {
    return res.json().then(function (data) {
      var already = !!(data && (data.duplicate || /already|taken|exist/i.test(String(data.error || ''))));
      if (already) {
        ageSignupError('This email has already been used.');
        return new Promise(function (resolve) { window.setTimeout(resolve, 1400); });
      }
      if (data && data.created && data.code) {
        ageSignupError('Your 10% off code is ' + data.code + '. We also emailed it.');
        return new Promise(function (resolve) { window.setTimeout(resolve, 2500); });
      }
      if (!res.ok || (data && data.error)) {
        var fail = String(data && data.error || '');
        if (fail === 'rate' || res.status === 429) ageSignupError('Too many tries. Leave the email blank to enter, or wait and try again.');
        else ageSignupError('Could not save email. Leave it blank to enter, or try again.');
        throw new Error('signup');
      }
    }, function () {
      if (res.ok) return;
      ageSignupError('Could not save email. Leave it blank to enter, or try again.');
      throw new Error('signup');
    });
  }).catch(function (err) {
    if (err && (err.message === 'email' || err.message === 'consent' || err.message === 'signup')) throw err;
    ageSignupError('Could not save email. Leave it blank to enter, or try again.');
    throw new Error('signup');
  });
}

function passAgeGate() {
  try {
    localStorage.setItem('gpc_age_verified', 'true');
  } catch (e) {}
  document.documentElement.classList.remove('gpc-age-peek');
  document.documentElement.classList.add('gpc-age-ok');
  hideAgeGate(document.getElementById('age-gate'));
}

function confirmAge() {
  var btn = document.getElementById('age-confirm-btn');
  if (btn) btn.disabled = true;
  submitAgeSignup().then(function () {
    passAgeGate();
  }, function (err) {
    if (btn) btn.disabled = false;
    if (err && (err.message === 'email' || err.message === 'consent' || err.message === 'signup')) return;
    passAgeGate();
  });
}

function declineAge() {
  const gate = document.getElementById('age-gate');
  if (!gate) return;
  gate.innerHTML =
    '<div class="gpc-age-card w-full bg-zinc-900 border border-zinc-700 rounded-2xl text-center shadow-2xl">' +
      '<p id="age-gate-title">Access denied</p>' +
      '<p class="gpc-age-copy">This site is for adults 18 and older.</p>' +
      '<a class="gpc-age-leave" href="https://www.google.com">Leave</a>' +
    '</div>';
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
}

function initTheme() {
  if (typeof initAgeGate === 'function') initAgeGate();

  syncCartFromShopify().catch(function (err) {
    console.error('Failed to sync cart count', err);
  });
  window.addEventListener('pageshow', function () {
    syncCartFromShopify().catch(function () {});
  });

  // Real Featured collection search (small curated set)
  const searchInput = document.getElementById('search-input');
  const grid = document.getElementById('product-grid');
  if (searchInput) {
    if (grid && grid.dataset.realProducts) {
      searchInput.addEventListener('input', filterRealFeaturedProducts);
    } else if (typeof filterRealFeaturedProducts === 'function') {
      // Fallback for any grids
      searchInput.addEventListener('input', filterRealFeaturedProducts);
    }
  }

  // Keyboard shortcuts
  document.addEventListener('keydown', (e) => {
    if (e.key === '/' && document.activeElement.tagName === 'BODY') {
      e.preventDefault();
      searchInput?.focus();
    }
    if (e.key === 'Escape') {
      const drawer = document.getElementById('cart-drawer');
      if (drawer && !drawer.classList.contains('hidden')) {
        if (typeof hideCart === 'function') hideCart();
      }
    }
  });

}

if (typeof initTheme === 'function') initTheme();

setTimeout(function () {
  var searchInput = document.getElementById('search-input');
  var container = document.getElementById('algolia-autocomplete');
  if (searchInput && typeof attachMobileSearchFocusStabilizer === 'function') {
    attachMobileSearchFocusStabilizer(searchInput, container);
  }
}, 150);

if (typeof initAgeGate === 'function') {
  setTimeout(initAgeGate, 50);
}

(function gpcNavidiumLogo() {
  var src = (window.GPC && window.GPC.logoUrl) || '';
  if (!src) return;
  function isOurs(url) {
    return url && (url.indexOf('gunpartscentral') !== -1 || url.indexOf('GunPartsCentral') !== -1);
  }
  function swap() {
    document.querySelectorAll('#nvd-standard-widget-logo, .nvd-std-widget-logo').forEach(function (box) {
      var img = box.querySelector('img');
      if (img) {
        if (isOurs(img.getAttribute('src') || img.src)) return;
        img.src = src;
        img.removeAttribute('srcset');
        img.alt = 'Gun Parts Central';
        return;
      }
      if (box.querySelector('img.gpc-nvd-logo')) return;
      var n = document.createElement('img');
      n.className = 'gpc-nvd-logo';
      n.src = src;
      n.alt = 'Gun Parts Central';
      box.innerHTML = '';
      box.appendChild(n);
    });
  }
  swap();
  document.addEventListener('DOMContentLoaded', swap);
  try {
    new MutationObserver(swap).observe(document.documentElement, { childList: true, subtree: true });
  } catch (err) {}
})();

(function initTrustTicker() {
  var root = document.querySelector('[data-gpc-ticker]');
  if (!root) return;
  var track = root.querySelector('.gpc-ticker-track');
  var set = root.querySelector('.gpc-ticker-set');
  if (!track || !set) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sourceHTML = set.innerHTML;
  var stockN = null;
  var showArrivals = false;
  var pxPerSec = 72;

  function applyStock(node) {
    if (stockN == null) return;
    var items = node.querySelectorAll('[data-gpc-stock-label]');
    var text = 'Real-time inventory: ' + Number(stockN).toLocaleString('en-US') + ' gun parts in stock';
    for (var i = 0; i < items.length; i++) items[i].textContent = text;
  }

  function applyArrivals(node) {
    var items = node.querySelectorAll('[data-gpc-arrivals]');
    for (var i = 0; i < items.length; i++) {
      if (showArrivals) items[i].removeAttribute('hidden');
      else items[i].setAttribute('hidden', '');
    }
  }

  function rebuild() {
    set.innerHTML = sourceHTML;
    applyStock(set);
    applyArrivals(set);
    while (track.children.length > 1) track.removeChild(track.lastChild);
    if (reduce) return;
    var minW = root.offsetWidth || 320;
    var guard = 0;
    while (set.scrollWidth < minW && guard < 12) {
      set.insertAdjacentHTML('beforeend', sourceHTML);
      applyStock(set);
      applyArrivals(set);
      guard += 1;
    }
    track.appendChild(set.cloneNode(true));
    var half = track.scrollWidth / 2;
    var s = Math.max(16, half / pxPerSec);
    track.style.setProperty('--gpc-ticker-s', s + 's');
  }

  rebuild();

  document.addEventListener('visibilitychange', function () {
    if (!track) return;
    track.style.animationPlayState = document.hidden ? 'paused' : '';
  });

  function applyExactStock(n) {
    if (typeof n !== 'number') return;
    stockN = n;
    rebuild();
  }
  if (window.GPC && typeof window.GPC.ensureInStockCount === 'function') {
    window.GPC.ensureInStockCount(applyExactStock);
  }

  var arrivalsUrl = window.GPC && window.GPC.arrivalsUrl;
  if (arrivalsUrl) {
    fetch(arrivalsUrl, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        if (typeof data.inStockCount === 'number' && window.GPC && typeof window.GPC._setInStockCount === 'function') {
          window.GPC._setInStockCount(data.inStockCount);
        }
        var nNew = data.newCount || (data.new && data.new.length) || 0;
        var nRestock = data.restockCount || (data.restock && data.restock.length) || 0;
        if (nNew > 0 || nRestock > 0) {
          showArrivals = true;
          rebuild();
        }
      })
      .catch(function () {});
  }

  if (!reduce && window.ResizeObserver) {
    var t = null;
    new ResizeObserver(function () {
      clearTimeout(t);
      t = setTimeout(rebuild, 120);
    }).observe(root);
  }
})();

(function initTickerHideOnScroll() {
  var lastY = window.scrollY || 0;
  var away = false;
  var ticking = false;
  function setAway(next) {
    if (next === away) return;
    away = next;
    document.documentElement.classList.toggle('gpc-ticker-away', away);
    if (typeof window.gpcSyncHeaderOffset === 'function') window.gpcSyncHeaderOffset();
  }
  function onScroll() {
    ticking = false;
    var y = window.scrollY || 0;
    var dy = y - lastY;
    lastY = y;
    if (y < 12) {
      setAway(false);
      return;
    }
    if (dy > 4) setAway(true);
    else if (dy < -4) setAway(false);
  }
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(onScroll);
  }, { passive: true });
  ['transitionend', 'transitioncancel'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('.gpc-trust-bar, .gpc-desktop-nav')) return;
      if (typeof window.gpcSyncHeaderOffset === 'function') window.gpcSyncHeaderOffset();
    });
  });
})();
